import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout/Index';
import beforeEach from './beforeEach';

Vue.use(VueRouter);

const routes = [
	{
		path: '*',
		redirect: '/',
		name: 'NotFound',
	},
	{
		path: '/',
		component: Layout,
		redirect: '/ecommerce/analytics',
		children: [
			{
				path: '/ecommerce/analytics',
				component: () => import('@/views/analytics/ecommerce/ecommerce.vue'),
				name: 'Analytics',
				meta: {
					title: 'Analytics',
				},
			},
			{
				path: '/ecommerce/componentes',
				component: () => import('@/views/componentes/componentes.vue'),
				name: 'Componentes',
				meta: {
					title: 'Componentes',
				},
			},
			{
				path: '/ecommerce/componentes/editar/:id',
				component: () => import('@/views/componentes/edit.vue'),
				name: 'ComponenteEditar ',
				meta: {
					title: 'Componente',
				},
			},
			{
				path: '/analytics/empresas/',
				component: () => import('@/views/analytics/empresas/empresas.vue'),
				name: 'Empresas',
				meta: {
					title: 'Empresas',
				},
			},
			{
				path: '/analytics/empresas/detalhes/:id',
				component: () => import('@/views/analytics/empresas/detalhes.vue'),
				name: 'Empresa - Detalhes',
				meta: {
					title: 'Empresa - Detalhes',
				},
			},
			{
				path: 'about',
				component: () => import('@/views/dashboard/overview/Overview.vue'),
				name: 'About',
				meta: {
					title: 'About',
				},
			},
			{
				path: 'integracoes',
				component: () => import('@/views/integracoes'),
				name: 'Integracoes',
				meta: {
					title: 'Integrações',
				},
			},
			{
				path: 'precadastro',
				component: () => import('@/views/precadastro'),
				name: 'PreCadastro',
				meta: {
					title: 'Pré Cadastro',
				},
			},
			{
				path: 'precadastro/edit/:id',
				component: () => import('@/views/precadastro/edit.vue'),
				name: 'PrecadastroEdit',
				meta: {
					title: 'Pré Cadastro - Editar',
				},
			},
			{
				path: 'precadastro/details/:id',
				component: () => import('@/views/precadastro/details.vue'),
				name: 'PrecadastroDetails',
				meta: {
					title: 'Pré Cadastro - ',
				},
			},
			{
				path: '/suporte',
				component: () => import('@/views/suporte/index.vue'),
				name: 'Suporte',
			},
		],
	},

	{
		path: '/order',
		component: Layout,
		redirect: '/order/orders',
		children: [
			{
				path: 'orders',
				component: () => import('@/views/pedidos/index.vue'),
				name: 'Pedidos',
				meta: {
					title: 'Pedidos',
				},
			},
			{
				path: '/order/:id/details',
				component: () => import('@/views/pedidos/details.vue'),
				name: 'PedidoDetails',
				meta: {
					title: 'Detalhes',
				},
			},
		],
	},
	{
		path: '/produtos',
		component: Layout,
		redirect: '/produtos/grupos',
		children: [
			{
				path: 'grupos',
				component: () => import('@/views/produtos/grupos/grupos.vue'),
				name: 'GruposProdutos',
				meta: {
					title: 'Grupos de produtos',
				},
			},
			{
				path: 'grupos/:id',
				component: () => import('@/views/produtos/grupos/edit.vue'),
				name: 'GrupoEdit',
				meta: {
					title: 'Edit',
				},
			},
		],
	},
	{
		path: '/cartao',
		component: Layout,
		redirect: '/cartao/pagamento',
		children: [
			{
				path: 'pagamento',
				component: () => import('@/views/cartao'),
				name: 'PagamentoCartao',
				meta: {
					title: 'Pagamento',
				},
			},
			{
				path: 'pagamento/detalhes/:id/:gateway',
				component: () => import('@/views/cartao/details.vue'),
				name: 'PagamentoCartaoDetails',
				meta: {
					title: 'Pagamento Cartão - Detalhes',
				},
			},
		],
	},
	{
		path: '/usuarios',
		component: Layout,
		redirect: '/usuarios/list',
		children: [
			{
				path: '/usuarios/list',
				component: () => import('@/views/usuarios/list.vue'),
				name: 'Usuarios',
				meta: {
					title: 'Usuários',
				},
			},
			{
				path: '/usuarios/edit/:id',
				component: () => import('@/views/usuarios/edit.vue'),
				name: 'UsuariosEditar',
				meta: {
					title: 'Editar',
				},
			},
			{
				path: '/usuarios/list/:id',
				component: () => import('@/views/usuarios/details.vue'),
				name: 'UsuariosDetails',
				meta: {
					title: 'Usuário - Detalhes',
				},
			},
			{
				path: '/usuarios/novo',
				component: () => import('@/views/usuarios/new.vue'),
				name: 'UsuariosAdicionar',
				meta: {
					title: 'Adicionar Usuário',
				},
			},
		],
	},
	{
		path: '/cadastro',
		component: Layout,
		redirect: '/cadastro/pagamento',
		children: [
			{
				path: '/cadastro/fpagamento',
				component: () => import('@/views/fpagamento/index.vue'),
				name: 'FormaPagamento',
				meta: {
					title: 'Forma de Pagamento',
				},
			},
			{
				path: '/cadastro/fpagamento/details/:id',
				component: () => import('@/views/fpagamento/details.vue'),
				name: 'FormaPagamentoDetails',
				meta: {
					title: 'Forma de Pagamento - Detalhes',
				},
			},
			{
				path: '/cadastro/condpagamento',
				component: () => import('@/views/condpagamento/index.vue'),
				name: 'CondPagamento',
				meta: {
					title: 'Condição de Pagamento',
				},
			},
			{
				path: '/cadastro/tabvendas',
				component: () => import('@/views/tabvendas/index.vue'),
				name: 'TabVendas',
				meta: {
					title: 'Tabela de Vendas',
				},
			},
		],
	},
	{
		path: '/login',
		component: () => import('@/views/login/Login'),
		name: 'Login',
	},
	{
		path: '/admin',
		component: Layout,
		redirect: '/admin/permissions',
		children: [
			{
				path: 'permissions',
				component: () => import('@/views/admin/permission/Permission.vue'),
				name: 'SettingPermission',
			},
			{
				path: 'user/edit/:id',
				component: () => import('@/views/admUsers/edit.vue'),
				name: 'UsersEdit',
				meta: {
					title: 'Usuário - Editar',
				},
			},
			{
				path: 'user/new/',
				component: () => import('@/views/admUsers/new.vue'),
				name: 'UsersNew',
				meta: {
					title: 'Usuário - Novo',
				},
			},
			{
				path: 'user/view/:id',
				component: () => import('@/views/admUsers/view.vue'),
				name: 'AdmUsersDetails',
				meta: {
					title: 'Adm / Usuário - Detalhes',
				},
			},
			{
				path: 'user',
				component: () => import('@/views/admUsers/list.vue'),
				name: 'AdmUsers',
				meta: {
					title: 'Adm Usuários',
				},
			},
			{
				path: 'roles',
				component: () => import('@/views/admin/role/Role.vue'),
				name: 'SettingRole',
			},
			{
				path: 'menus',
				component: () => import('@/views/admin/menu/Menu.vue'),
				name: 'SettingMenu',
				meta: {
					title: 'Menus',
				},
			},
		],
	},
	{
		path: '/ecommerce',
		component: Layout,
		redirect: '/ecommerce/list',
		children: [
			{
				path: '/ecommerce/list',
				component: () => import('@/views/ecommerce/list.vue'),
				name: 'Produtos em Destaque',
			},
			{
				path: '/ecommerce/edit/:id',
				component: () => import('@/views/ecommerce/edit.vue'),
				name: 'Produtos em Destaque - Editar',
			},
		],
	},
	{
		path: '/curriculos',
		component: Layout,
		redirect: '/curriculos/list',
		children: [
			{
				path: '/curriculos/list',
				component: () => import('@/views/curriculos/list.vue'),
				name: 'Gestão de currículos',
			},
			{
				path: '/curriculos/details/:id',
				component: () => import('@/views/curriculos/details.vue'),
				name: 'Gestão de currículos - Detalhes',
			},
		],
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach(beforeEach);

export default router;

